import { useRouteSummary } from '$contexts/RouteContext/hooks'
import {
  deleteAppLaunchpad,
  getAppLaunchpads,
  postAppLaunchpad,
  putAppLaunchpad
} from '$services/api'
import { useRequest } from 'ahooks'
import { toast } from 'sonner'

export const useAppLaunchpadService = () => {
  const { route } = useRouteSummary()
  const { appId = '' } = route.params

  const {
    data: appLaunchpadData,
    run: fetchAppLaunchpads,
    runAsync: fetchAppLaunchpadsAsync,
    loading: fetchingAppLaunchpads
  } = useRequest(getAppLaunchpads, {
    manual: true
  })

  const { launchpads = [] } = appLaunchpadData?.data ?? {}

  const {
    run: addAppLaunchpad,
    runAsync: addAppLaunchpadAsync,
    loading: addingAppLaunchpad
  } = useRequest(postAppLaunchpad, {
    manual: true,
    onSuccess: () => {
      toast.success('Successfully Created!')
      fetchAppLaunchpads({ application_id: appId })
    }
  })

  const {
    run: updateAppLaunchpads,
    runAsync: updateAppLaunchpadsAsync,
    loading: updatingAppLaunchpads
  } = useRequest(putAppLaunchpad, {
    manual: true,
    onSuccess: () => {
      toast.success('Successfully Updated!')
      fetchAppLaunchpads({ application_id: appId })
    }
  })

  const {
    run: removeAppLaunchpad,
    runAsync: removeAppLaunchpadAsync,
    loading: removingAppLaunchpad
  } = useRequest(deleteAppLaunchpad, {
    manual: true,
    onSuccess: () => {
      toast.success('Successfully Deleted!')
      fetchAppLaunchpads({ application_id: appId })
    }
  })

  return {
    launchpads,
    fetchAppLaunchpads,
    fetchAppLaunchpadsAsync,
    fetchingAppLaunchpads,

    addAppLaunchpad,
    addAppLaunchpadAsync,
    addingAppLaunchpad,

    updateAppLaunchpads,
    updateAppLaunchpadsAsync,
    updatingAppLaunchpads,

    removeAppLaunchpad,
    removeAppLaunchpadAsync,
    removingAppLaunchpad
  }
}
